import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _isEqual from "lodash/isEqual";
import _has from "lodash/has";
import "core-js/modules/es.array.map.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { VideoGridItem } from "../../Video/VideoGridItem/VideoGridItem";
import { VideoPlayer } from "../../Video/VideoPlayer/VideoPlayer";
import { ToggleButton } from "../../Button/ToggleButton/ToggleButton";
import styles from "./VideoGridSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VideoGridSlice = function VideoGridSlice(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$showText = _ref.showText,
    showText = _ref$showText === void 0 ? {
      more: 'Show more videos',
      less: 'Show less videos'
    } : _ref$showText,
    videoList = _ref.videoList,
    _ref$largeCardActionA = _ref.largeCardActionAttributes,
    largeCardActionAttributes = _ref$largeCardActionA === void 0 ? {} : _ref$largeCardActionA;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mainVideo = _useState2[0],
    setMainVideo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show = _useState4[0],
    setShow = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPlaying = _useState6[0],
    setIsPlaying = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currId = _useState8[0],
    setCurrId = _useState8[1];
  var prevVideo = useRef(mainVideo);
  var prevId = useRef(currId);
  useEffect(function () {
    if (mainVideo) {
      var _videoList$currId, _prevVideo$current, _videoList$currId2, _prevVideo$current2;
      if (!videoList[currId] && videoList[prevId.current]) {
        setMainVideo(null);
        prevVideo.current = null;
        prevId.current = currId;
      }
      if (((_videoList$currId = videoList[currId]) === null || _videoList$currId === void 0 ? void 0 : _videoList$currId.caption) !== ((_prevVideo$current = prevVideo.current) === null || _prevVideo$current === void 0 ? void 0 : _prevVideo$current.caption)) {
        setMainVideo(videoList[currId]);
        prevVideo.current = videoList[currId];
        prevId.current = currId;
      }
      if ((_videoList$currId2 = videoList[currId]) !== null && _videoList$currId2 !== void 0 && _videoList$currId2.video && (_prevVideo$current2 = prevVideo.current) !== null && _prevVideo$current2 !== void 0 && _prevVideo$current2.video) {
        var _videoList$currId3;
        var newVideo = (_videoList$currId3 = videoList[currId]) === null || _videoList$currId3 === void 0 ? void 0 : _videoList$currId3.video;
        var oldVideo = prevVideo.current.video;
        if (_has(oldVideo, 'playOnVideoUpdate')) {
          delete oldVideo.playOnVideoUpdate;
        }
        if (_has(newVideo, 'playOnVideoUpdate') && newVideo) {
          delete newVideo.playOnVideoUpdate;
        }

        // Update video if e.g. autoplay settings or videoId have changed.
        // It's for better user expirience in Editor app.
        if (!_isEqual(newVideo, oldVideo)) {
          setMainVideo(videoList[currId]);
          prevVideo.current = videoList[currId];
          prevId.current = currId;
        }
      }
    }
  }, [mainVideo, videoList, currId, prevId, prevVideo]);
  var onMainPlay = function onMainPlay() {
    setIsPlaying(true);
  };
  var onMainPause = function onMainPause() {
    setIsPlaying(false);
  };
  var itemClick = function itemClick(itemKey) {
    setMainVideo(_objectSpread(_objectSpread({}, videoList[itemKey]), {}, {
      video: _objectSpread(_objectSpread({}, videoList[itemKey].video), {}, {
        playOnVideoUpdate: true
      })
    }));
    setCurrId(itemKey);
    prevVideo.current = videoList[itemKey];
    prevId.current = itemKey;
  };
  var renderItem = function renderItem(video, index) {
    var playing = currId === index && isPlaying;
    return /*#__PURE__*/_jsx(VideoGridItem, {
      className: classnames(styles.videoItem, {
        [styles.videoItemShow]: index <= 2 || show
      }),
      onClick: function onClick() {
        itemClick(index);
      },
      playing: playing,
      thumbnail: video.thumbnail,
      title: video.title,
      duration: video.duration,
      cardActionAttributes: video.cardActionAttributes ? video.cardActionAttributes : {}
    }, index);
  };
  var currentVideo = mainVideo || (videoList ? videoList[0] : null);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [title && /*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: /*#__PURE__*/_jsx(HeadingText, {
        typog: "headline3",
        children: title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.mainVideoWrapper, 'videoColumn'),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.mainVideo,
        children: currentVideo && /*#__PURE__*/_jsx(VideoPlayer, _objectSpread(_objectSpread({}, currentVideo), {}, {
          cardActionAttributes: largeCardActionAttributes,
          onPlay: onMainPlay,
          onPause: onMainPause
        }))
      })
    }), /*#__PURE__*/_jsx(Container, {
      className: styles.blockOverride,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.grid,
        children: videoList && videoList.map(renderItem)
      })
    }), (videoList === null || videoList === void 0 ? void 0 : videoList.length) >= 4 && /*#__PURE__*/_jsx("div", {
      className: styles.showMoreWrapper,
      children: /*#__PURE__*/_jsx(ToggleButton, {
        className: styles.showMoreWrapperButton,
        iconPosition: "right",
        styleType: "default",
        childStyles: styles.showMoreWrapperButtonText,
        onPress: function onPress() {
          setShow(!show);
        },
        children: show ? showText.less : showText.more
      })
    })]
  });
};